export default {
  namespaced: true,
  state: {
    btnRole: []
  },
  actions: {
    async btnRoleSet({ commit, dispatch }, btnRole) {
      commit('btnRoleSet', btnRole)
      await dispatch(
        'admin/db/set',
        {
          dbName: 'sys',
          path: 'permission.btnRole',
          value: btnRole,
          user: true
        },
        { root: true }
      )
    },
    async getBtnRole({ state, dispatch }) {
      if (state.btnRole && state.btnRole.length) {
        return state.btnRole
      }
      return await dispatch(
        'admin/db/get',
        {
          dbName: 'sys',
          path: 'permission.btnRole',
          defaultValue: [],
          user: true
        },
        { root: true }
      )
    },
    clearBtnRole({ commit }) {
      commit('clearBtnRole')
    }
  },
  mutations: {
    clearBtnRole(state) {
      state.btnRole = []
    },
    btnRoleSet(state, btnRole) {
      state.btnRole = btnRole
    }
  }
}
